export default {
  en: {
    translation: {
      metadataPage: {
        title: 'Structured Metadata Values',
        subtitle: '1 asset selected',
        subtitle_plural: '{{count}} assets selected',
        tooltip: 'Some required metadata fields are not set or the supplied values are invalid.',
        upload: 'Upload',
        conflict_label: 'Overwrite',
        intro: {
          openingText: 'You can fill in the following fields to add new metadata to your assets on upload.',
          conflictWarning: 'Note: Select ‘Overwrite’ for the fields where you want to apply the new values to both new and replaced assets.',
          closingText: 'After upload, you can modify metadata for individual assets from the Media Library.',
        },
        closePrompt: 'Are you sure you want to close this dialog box? Your files will not be uploaded.',
        backPrompt: 'Are you sure? Your file selection and the metadata values you entered will be lost.',
        approveCancel: 'Yes',
        cancel: 'Cancel',
        validationErrors: {
          string: {
            min: 'Must be at least {{min}} characters.',
            max: "Can't be more than {{max}} characters.",
            minAndMax: 'Must be between {{min}}-{{max}} characters long.',
            //TODO: need to test with regex (not possible currently)
            regex: 'Must include only XXXX.',
          },
          integer: {
            lessThan: 'Must be less than {{less}}.',
            lessThanEqual: "Can't be more than {{max}}.",
            greaterThan: 'Must be more than {{more}}.',
            greaterThanEqual: 'Must be at least {{min}}.',
          },
          number: {
            lessThan: 'Must be less than {{less}}.',
            lessThanEqual: "Can't be more than {{max}}.",
            greaterThan: 'Must be more than {{more}}.',
            greaterThanEqual: 'Must be at least {{min}}.',
          },
          enum: {
            oneOf: '{{originalValue}} needs to be one of the specified options above.',
          },
          set: {
            oneOf: '{{originalValue}} needs to be one of the specified options above.',
          },
          date: {
            lessThan: 'Must be before {{max}}.',
            lessThanEqual: 'Can’t be after {{max}}.',
            greaterThan: 'Must be after {{min}}.',
            greaterThanEqual: 'Can’t be before {{min}}.',
          },
          stringError: 'Must be text.',
          numberError: 'Must be a number.',
          integerError: 'Must be a number.',
          dateError: 'Must be a date.',
          enumError: 'Choose one of the specified options.',
          setError: 'Choose at least one of the specified options.',
          required: 'This field is required.',
          integerTypeError: 'This is an integer field.',
          digitsLimitError: 'This number cannot be more than 16 digits long.',
          unsupportedFields: 'Please contact your administrator, there is a problem with the following optional metadata fields: ',
          unsupportedRequiredFields: 'Please contact your administrator, there is a problem with the following mandatory metadata fields: ',
        },
      },
    },
  },
};
